/* ═══════════════════════════════════════════════════════════════
   FirmContext — Provides current user's firm_id to all services
   ═══════════════════════════════════════════════════════════════ */

let _firmId: string | null = null;

export function setCurrentFirmId(firmId: string | null) {
  _firmId = firmId;
}

export function getCurrentFirmId(): string {
  if (!_firmId) throw new Error('No firm context set. User must be logged in.');
  return _firmId;
}
